export enum BillingEventNameAMP {
  PAYMENT_REQUIREMENT_MODAL_OPEN = 'payment requirement modal was opened',
  PAYMENT_REQUIREMENT_MODAL_SUBMIT = 'move to billing page was clicked',
  PAYMENT_MODAL_SUBMIT_PAYMENT = 'payment button in license modal was clicked',
  PAYMENT_MODAL_SUBMIT_CONFIRM = 'confirm button in license modal was clicked',
}
